import { __assign } from "tslib";
import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import useIntl from '../useIntl';
import { getDisplayName } from '../utils';
/**
 * React Higher Order Component to add intl formatter to a components props
 */
function withFormatter(Component) {
    if (process.env.NODE_ENV !== 'production') {
        if (Component === undefined) {
            throw new Error([
                'You are calling withFormatter(Component) with an undefined component.',
                'You may have forgotten to import it.',
            ].join('\n'));
        }
    }
    var WithFormatter = React.forwardRef(function WithIntl(props, ref) {
        var intl = useIntl();
        return React.createElement(Component, __assign({ formatter: intl, ref: ref }, props));
    });
    if (process.env.NODE_ENV !== 'production') {
        WithFormatter.displayName = "WithFormatter(".concat(getDisplayName(Component), ")");
    }
    hoistNonReactStatics(WithFormatter, Component);
    return WithFormatter;
}
export default withFormatter;
